var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandmarks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H17.6923V14.8467H13.7433L9.13878 20L4.50375 14.8467H0V0ZM1.58895 1.57576H16.1034V13.2708H13.0391L9.13636 17.625L5.23359 13.2708H1.58895V1.57576Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1119 6.44055V4.38348C12.1119 4.17998 11.9965 3.99376 11.8136 3.902L9.09217 2.53367C8.93759 2.45595 8.75471 2.45595 8.60014 2.53367L5.87868 3.902C5.6958 3.9943 5.58041 4.17998 5.58041 4.38348V6.44055L3.69989 7.39433C3.51755 7.48663 3.40325 7.67231 3.40325 7.87473V11.1117C3.40325 11.7082 3.89039 12.1913 4.49183 12.1913H7.21328V10.0322C7.21328 9.73424 7.45712 9.49242 7.75757 9.49242H9.93474C10.2352 9.49242 10.479 9.73424 10.479 10.0322V12.1913H13.2005C13.8019 12.1913 14.2891 11.7082 14.2891 11.1117V7.87473C14.2891 7.67231 14.1748 7.48663 13.9924 7.39433L12.1119 6.44055ZM8.30186 5.17424H9.39044C9.69089 5.17424 9.93474 5.41606 9.93474 5.71401V6.79356C9.93474 7.09151 9.69089 7.33333 9.39044 7.33333H8.30186C8.00142 7.33333 7.75757 7.09151 7.75757 6.79356V5.71401C7.75757 5.41606 8.00142 5.17424 8.30186 5.17424Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmarks);
export default __webpack_public_path__ + "static/media/Landmarks.fe96b4e8e91f1dd6196d315218568a18.svg";
export { ForwardRef as ReactComponent };